import { c as _c } from "react/compiler-runtime";
import React from 'react';
import useLocation from './useLocationMock';
import useHistory from './useHistoryMock';
import { isPopNavigation } from './navStateBridge';
import withRouter from './withRouterMock';
import Link from './LinkMock';
import Route from './RouteMock';
import Redirect from './RedirectMock';
import useParamsMock from './useParamsMock';
import useRouteMatch from './useRouteMatchMock';
const Switch = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <div {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
const Router = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <div {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
const BrowserRouter = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <div {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
const matchPath = () => ({
  isExact: true
});

// TODO: Update this mock to load real values from Next.js router - covered in
// multiple tickets in Next.js epics
export { BrowserRouter, Link, matchPath, Redirect, Route, Router, Switch, useHistory, isPopNavigation, useLocation, useParamsMock as useParams, useRouteMatch, withRouter };